module.exports = __webpack_public_path__ + "static/avatar-rebecca-9411bd18cdba5eb5b27de0fc108f16f5.png";